export default "__VITE_ASSET__aACg$Aay__"